'use strict';

var React = require('react');

var SvgChatReferralIcon = function SvgChatReferralIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.75a3.25 3.25 0 0 1 3.25-3.25h3.75a.75.75 0 0 0 0-1.5h-3.75a4.75 4.75 0 0 0-4.75 4.75v.75c0 2.1 1.362 3.88 3.25 4.508v1.992a.75.75 0 0 0 1.196.603l3.178-2.353h1.626a4.75 4.75 0 0 0 4.75-4.75.75.75 0 0 0-1.5 0 3.25 3.25 0 0 1-3.25 3.25h-1.873a.75.75 0 0 0-.447.147l-2.18 1.614v-1.081a.75.75 0 0 0-.61-.737 3.251 3.251 0 0 1-2.64-3.193v-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4a.75.75 0 0 0 0 1.5h.69l-3.22 3.22a.75.75 0 0 0 1.06 1.06l3.22-3.22v.69a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75h-2.5Z"
  }));
};
SvgChatReferralIcon.displayName = "ChatReferralIcon";

exports.SvgChatReferralIcon = SvgChatReferralIcon;
